import { JsonSerializable } from '@/util/object/JsonSerializable'
import { CatalogBrandResponse } from '@/cowboy/catalog/object/CatalogBrandResponse'

export class CatalogResponse extends JsonSerializable {
  /** @type {number} */
  #catalogID
  /** @type {string} */
  #name
  /** @type {string} */
  #description
  /** @type {Array<CatalogBrandResponse>} */
  #brands
  /** @type {string} */
  #displayLocale
  /** @type {string} */
  #modifier
  /** @type {Date} */
  #createdAt
  /** @type {Date} */
  #lastUpdated

  constructor (jsonObject) {
    super()
    this.#catalogID = Number.parseInt(jsonObject.catalogID) || undefined
    this.#name = jsonObject.name
    this.#description = jsonObject.description
    this.#brands = jsonObject.brands?.map(brand => CatalogBrandResponse.fromJSON(brand)) || []
    this.#displayLocale = jsonObject.displayLocale
    this.#modifier = jsonObject.modifier
    this.#createdAt = new Date(jsonObject.createdAt || undefined)
    this.#lastUpdated = new Date(jsonObject.lastUpdated || undefined)
    Object.freeze(this)
  }

  /**
   * Catalog Identifier
   * @return {number}
   */
  get catalogID () {
    return this.#catalogID
  }

  /**
   * @deprecated never used
   * Catalog Name
   * @return {string}
   */
  get name () {
    return this.#name
  }

  /**
   * @deprecated never used
   * Catalog description
   * @return {string}
   */
  get description () {
    return this.#description
  }

  /**
   * Catalogs brands
   * @return {Array<CatalogBrandResponse>}
   */
  get brands () {
    return this.#brands
  }

  /**
   * @deprecated
   * Catalog displayed locale
   * @return {string}
   */
  get displayLocale () {
    return this.#displayLocale
  }

  /**
   * @deprecated never used, always null
   * Catalog modifier
   * @return {string}
   */
  get modifier () {
    return this.#modifier
  }

  /**
   * @deprecated never used
   * Catalog created date
   * @return {Date}
   */
  get createdAt () {
    return this.#createdAt
  }

  /**
   * @deprecated never used
   * Catalog last modified date
   * @return {Date}
   */
  get lastUpdated () {
    return this.#lastUpdated
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      catalogID: this.#catalogID,
      name: this.#name,
      description: this.#description,
      brands: this.#brands?.map(brand => brand.toJSON()),
      displayLocale: this.#displayLocale,
      modifier: this.#modifier,
      createdAt: this.#createdAt?.valueOf() || undefined,
      lastUpdated: this.#lastUpdated?.valueOf() || undefined
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {CatalogResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new CatalogResponse(jsonObject)) || undefined
  }
}
